<template>
    <div :class="prefixCls">
        <div :class="`${prefixCls}-fixed`" ref="scrollContent">
            <div v-if='insearch' :class="`${prefixCls}-tab ${prefixCls}-tab-active`">
                {{t('selectMember.search')}}
            </div>
            <template v-else>
                <div v-for="(tab, key) in tabs" :key="key"
                    :class="[
                        `${prefixCls}-tab`,
                        {
                            [`${prefixCls}-tab-active`]: tab === activeTab
                        }
                    ]"
                    @click="handleSwitchTab(tab)">
                    {{tabsPane[tab]}}
                </div>
                <div v-for="(tab) in customTabs" 
                    :key="tab.key"
                    :class="[
                        `${prefixCls}-tab`,
                        {
                            [`${prefixCls}-tab-active`]: tab.key === activeTab
                        }
                    ]"
                    @click="handleSwitchTab(tab.key)">
                    {{tab.title}}
                </div>
            </template>
        </div>
        <div :class="`${prefixCls}-body`" v-show="insearch">
            <Search 
                @handleSelected="handleSelected" />
        </div>
        <div :class="`${prefixCls}-body`" v-show="!insearch">
            <keep-alive>
                <SectionDept 
                    v-if="activeTab === 'dept'"
                    :withMembers="false"
                    @handleSelected="handleSelected" />
            </keep-alive>
            <keep-alive>
                <SectionDept 
                    v-if="activeTab === 'deptMember'"
                    :withMembers="true" 
                    @handleSelected="handleSelected" />
            </keep-alive>
            <keep-alive>
                <SectionGroup 
                    v-if="activeTab === 'group'"
                    :withMembers="false" 
                    @handleSelected="handleSelected"/>
            </keep-alive>
            <keep-alive>
                <SectionGroup 
                    v-if="activeTab === 'groupMember'"
                    :withMembers="true" 
                    @handleSelected="handleSelected"/>
            </keep-alive>
            <keep-alive>
                <SectionTeam 
                    v-if="activeTab === 'team'"
                    :withMembers="false" 
                    @handleSelected="handleSelected" />
            </keep-alive>
            <keep-alive>
                <SectionTeam 
                    v-if="activeTab === 'teamMember'"
                    :withMembers="true"
                    @handleSelected="handleSelected" />
            </keep-alive>
            <keep-alive>
                <SectionMember 
                    v-if="activeTab === 'member'"
                    @handleSelected="handleSelected"/>
            </keep-alive>
            <keep-alive v-for="(tab) in customTabs" :key="tab.key">
                <SectionCustom 
                    v-if="activeTab === tab.key"
                    :data="tab.data"
                    @handleSelected="handleSelected"/>
            </keep-alive>
        </div>
    </div>
</template>
<script>
    import SectionDept from './section/section-dept'
    import SectionGroup from './section/section-group'
    import SectionTeam from './section/section-team'
    import SectionMember from './section/section-member'
    import SectionCustom from './section/section-custom'
    import Search from './search'
    import PerfectScrollbar from 'perfect-scrollbar'
    import Locale from '../../../mixins/locale'
    import {t} from '../../../locale/'

    const prefixCls = 'yy-select-member-section'
    export default {
        name: 'Section',
        props: ['tabs', 'selected', 'insearch', 'customTabs', 'defaultActiveTab'],
        mixins: [Locale],
        data() {
            return {
                prefixCls: prefixCls,
                activeTab: this.tabs[0],
                tabsPane: {
                    dept: t('selectMember.dept'),
                    deptMember: t('selectMember.deptMember'),
                    group: t('selectMember.group'),
                    groupMember: t('selectMember.groupMember'),
                    team: t('selectMember.team'),
                    teamMember: t('selectMember.teamMember'),
                    member: t('selectMember.member')
                },
                scroll: null,
                container: null
            }
        },
        components: {
            SectionDept,
            SectionGroup,
            SectionTeam,
            SectionMember,
            SectionCustom,
            Search
        },
        methods: {
            handleSwitchTab(tab) {
                this.activeTab = tab
            },
            handleSelected(data) {
                this.$emit('handleSelected', data)
            },
            setVerticalScroll() {
                this.container = this.$refs.scrollContent
                this.scroll = new PerfectScrollbar(this.container, {
                    wheelSpeed: 0.5,
                    wheelPropagation: false,
                    useBothWheelAxes: true,
                    minScrollbarLength: 60,
                    maxScrollbarLength: 300,
                    useBothWheelAxes: true
                })
            },
            setCustomMember() {
                if(this.defaultActiveTab) {
                    this.handleSwitchTab(this.defaultActiveTab)
                }
                if(this.customTabs) {
                    this.customTabs.forEach(tab => {
                        tab.data && tab.data.forEach(item => {
                            item.checked = item.checked || false
                            item.type = item.type || 0
                            if(item.checked) {
                                this.handleSelected(item)
                            }
                        })
                    })
                }
            }
        },
        created () {
            this.setCustomMember()  
        },
        mounted() {
            this.setVerticalScroll()
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/business/select-member/section.vue